import { getFolderResourceItems, resourceFolderFileUrl } from './folderResources';

const SEGMENT = 'assumewecan';

/** Files in public/resources/assumewecan/ - add one row per file. */
export const ASSUME_WE_CAN_RESOURCE_FILES = [
  {
    id: 'assume-we-can-pdf',
    title: 'Assume We Can',
    description: 'Project Infographics and Reports',
    filename: 'Assumewecan.pdf',
    icon: '📄',
  },
];

export function assumeWeCanResourceFileUrl(filename) {
  return resourceFolderFileUrl(SEGMENT, filename);
}

export function getAssumeWeCanResourceItems() {
  return getFolderResourceItems(SEGMENT, ASSUME_WE_CAN_RESOURCE_FILES).map((item) => ({
    ...item,
    sourceTag: 'LS Team',
  }));
}
